import axios from "axios";
import { BASE_URL } from "../../Config/BaseUrl";

const token = localStorage.getItem("token");

const createAxiosConfig = (url, method, data) => {
  return {
    method,
    url: `${BASE_URL}${url}/`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    data,
  };
};

export const MonthlyAttendenceAPI = {
    getMonthlyAttendance: async (data) => {
    const axiosConfig = createAxiosConfig(
      "get_monthly_attendance",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
    GetAttendanceData: async (data) => {
    const axiosConfig = createAxiosConfig(
      "get_attendance_data",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
  saveLeaveForStaff: async (data) => {
    const axiosConfig = createAxiosConfig(
      "save_leave_for_staff",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
  getLeaveList: async (data) => {
    const axiosConfig = createAxiosConfig(
      "get_leave_list",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
  deleteLeaveEntry: async (data) => {
    const axiosConfig = createAxiosConfig(
      "delete_leave_entry",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
  updateMonthlyAtt: async (data) => {
    const axiosConfig = createAxiosConfig(
      "update_monthly_att",
      "POST",
      data
    );
    return await axios(axiosConfig)
  },
 
};